"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteAppointmentRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.InviteAppointmentRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    counterName: (0, superstruct_1.string)(),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=InviteAppointmentRequest.js.map